import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-stars-02',
  imports: [],
  templateUrl: './stars-02.html',
  styleUrl: './stars-02.scss',
})
export class Stars02 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
